import core, { App } from '@gin-betting/core';

import { ParentPath } from 'types';

const {
    constants: { SportType },
} = core;

export default function getRouteBySportType(
    sportType: App.SportType | undefined
): ParentPath {
    switch (sportType) {
        case SportType.Classic: {
            return App.Routes.CLASSIC;
        }

        case SportType.Esport: {
            return App.Routes.ESPORT;
        }

        default: {
            return '';
        }
    }
}
